import { combineEpics } from 'redux-observable'
import trackPlayerEpics from '../features/music/trackPlayer/store/trackPlayer.epics'
import soundcloudEpics from '../soundcloud/soundcloud.epics'

const epics = [...soundcloudEpics, ...trackPlayerEpics]

export const rootEpic = combineEpics(...epics)
